/**
 * Particle burst effect on CTA hover
 */

import { ObjectPool, prefersReducedMotion } from '../core/utils.js';

export class ParticleBurst {
  #cta;
  #particlePool;
  #abortController = new AbortController();

  constructor() {
    this.#cta = document.getElementById('heroCta');
    
    if (!this.#cta || prefersReducedMotion()) {
      return;
    }

    this.#init();
  }

  #init() {
    // Object pool for particles
    this.#particlePool = new ObjectPool(
      () => {
        const el = document.createElement('div');
        el.className = 'particle-burst-particle';
        return el;
      },
      (el) => {
        el.style.cssText = '';
        if (el.parentNode) el.parentNode.removeChild(el);
      },
      20
    );

    const signal = this.#abortController.signal;
    
    this.#cta.addEventListener('mouseenter', (e) => {
      this.#burst(e.clientX, e.clientY);
    }, { signal });
  }

  #burst(x, y) {
    const colors = ['#d4af37', '#f5d76e', '#b8860b', '#7a5c00', '#ffe066'];
    const count = 14;

    for (let i = 0; i < count; i++) {
      const particle = this.#particlePool.acquire();
      if (!particle) continue;

      const angle = (Math.PI * 2 / count) * i;
      const dist = 40 + Math.random() * 60;

      Object.assign(particle.style, {
        position: 'fixed',
        left: `${x}px`,
        top: `${y}px`,
        width: `${Math.random() * 6 + 2}px`,
        height: `${Math.random() * 6 + 2}px`,
        background: colors[Math.floor(Math.random() * colors.length)],
        borderRadius: '50%',
        pointerEvents: 'none',
        zIndex: '9998'
      });

      document.body.appendChild(particle);

      const animation = particle.animate([
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: `translate(${Math.cos(angle) * dist}px, ${Math.sin(angle) * dist}px) scale(0)`, opacity: 0 }
      ], {
        duration: 600 + Math.random() * 400,
        easing: 'cubic-bezier(.23,1,.32,1)'
      });

      animation.onfinish = () => {
        this.#particlePool.release(particle);
      };
    }
  }

  destroy() {
    this.#abortController.abort();
    this.#particlePool?.releaseAll();
  }
}
